import { LIVE_TRACKING_UPDATE, BULK_CANCEL_ISINPROGRESS } from '../../constants/types';

function setLiveTrackingSetting(value) {
  return {
    type: LIVE_TRACKING_UPDATE,
    value,
  };
}

function setBulkCancelProgress(value) {
  return {
    type: BULK_CANCEL_ISINPROGRESS,
    value,
  };
}

export { setLiveTrackingSetting, setBulkCancelProgress };
